module.exports = __webpack_public_path__ + "media/images/products/products/modal/5-ace684827e4b788fd81ea91eb4b787d2.jpg";